import { useState } from "react";
import { Controller } from "react-hook-form";

const TaskList = ({ tasks, holidayArea, removeTask, removeHoliday, register, control, handleSliderChange, isEditMode, deleteSingleTask }) => {
  const [editableTasks, setEditableTasks] = useState({});
  const toggleEditMode = (index) => {
    setEditableTasks((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  return (
    <>
      {holidayArea.length > 0 && (
        <div className="holiday_area">
          {holidayArea.map((holiday, index) => (
             <div key={holiday.t_daily_work_task_id || `holiday-${index}`} className="col-lg-4 col-md-4 col-sm-6 col-xs-12 work-area">              <div className="work-box">
                <div className="work-num" data-index={index} data-cl_id="0" data-pr_id="0">
                  0.
                </div>
                <div className="work-txt">
                  <h2 className="h6">{holiday.holiday_name}</h2>
                </div>
                <div className="work-contents">
                  <textarea
                    className="form-control"
                    placeholder="MEMO"
                    {...register(`holidayArea.${index}.memo`)}
                  />
                </div>
                <span
                  className="glyphicon glyphicon-remove jq_task_close"
                  aria-hidden="true"
                  onClick={() => {
                    if (holiday.t_daily_work_task_id) {
                      deleteSingleTask(holiday.t_daily_work_task_id);
                    } else {
                      removeHoliday(index);
                    }
                  }}          
                ></span>
              </div>
            </div>
          ))}
        </div>
      )}

      <div className="task_area">
        {tasks
          .filter((task) => !(task.project_id === 0 && task.client_id === 0))
          .map((task, index) => (
            <div
              key={task.id_Api || `task-${index}`}
              className={`col-lg-4 col-md-4 col-sm-6 col-xs-12 work-area ${isEditMode ? "edit" : ""} normal_term`}>          
              <div className="work-box">
                <span className="glyphicon glyphicon-hand-up jq_task_move_icon" aria-hidden="true"></span>
                <div className="work-num" style={{ textAlign: "center" }} data-index={index + 1}>
                  {index + 1}
                </div>
                <div className="work-txt">
                  <h2 className="h6">
                    [{task.client_name}]{task.project_name}
                  </h2>
                </div>
                <div className="work-contents mb10 show_area2 set-text">
                  <textarea
                    className="form-control"
                    placeholder="MEMO"
                    {...register(`tasks.${index}.memo`)}
                    readOnly={isEditMode && !editableTasks[index]}
                  />
                  {isEditMode && (
                    <div className="edit-text">
                      <button
                        className="btn btn-default jq_edit_text"
                        type="button"
                        onClick={() => toggleEditMode(index)}
                      >
                        <span className="glyphicon glyphicon-pencil" aria-hidden="true"></span>
                      </button>
                    </div>
                  )}
                </div>
                <span
                  className="glyphicon glyphicon-remove jq_task_close"
                  aria-hidden="true"
                  onClick={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    if ( task.id_Api) {
                      deleteSingleTask(task.id_Api);
                    }else{
                      removeTask(index);
                    }
                   
                  }}
                  style={{
                    cursor: "pointer",
                    fontSize: "16px",
                    marginTop: 18,
                  }}
                ></span>

                {isEditMode && (
                  <>
                    <div className="ui-slider jq-slider">
                      <Controller
                        name={`tasks.${index}.progress_rate`}
                        control={control}
                        defaultValue={task.progress_rate || 0}
                        render={({ field }) => (
                          <input
                            type="range"
                            min="0"
                            max="100"
                            step="1"
                            {...field}
                            className="custom-range"
                            onChange={(e) => {
                              const value = Number.parseInt(e.target.value);
                              handleSliderChange(index, value);
                            }}
                          />
                        )}
                      />
                    </div>
                    <div
                      className="progress_time"
                      id={`progress_time_${index}`}
                      style={{
                        width: "150px",
                        textAlign: "center",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                      }}
                    >
                      0hours0minutes
                    </div>
                    <div className="slider-num" id="num_padding" style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                      <input
                        type="text"
                        {...register(`tasks.${index}.progress_rate`)}
                        style={{
                          width: "80px",
                          textAlign: "center",
                        }}
                        disabled
                      />
                      <span style={{ fontSize: "14px" }}>%</span>
                    </div>
                  </>
                )}
              </div>
            </div>
          ))}
      </div>
    </>
  );
};

export default TaskList;